var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    color: "#EBEBF5",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.008 5.8v2.366l-10.841 7.95-2.192-1.642c-.542-.408-.983-1.283-.983-1.958V5.799c0-.933.716-1.966 1.591-2.291l4.559-1.709c.475-.175 1.241-.175 1.716 0l4.559 1.709c.875.325 1.591 1.358 1.591 2.291Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.008 9.309v3.208c0 .675-.442 1.55-.983 1.958l-4.559 3.409c-.4.3-.933.45-1.466.45-.534 0-1.067-.15-1.467-.45l-1.6-1.192 10.075-7.383Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })));
};
export default SvgShield;